import { useAuthStore } from "./authStore";
function useAuth() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const user = useAuthStore((state) => state.user);
  const isRegistred = useAuthStore((state) => state.isRegistred);
  const validateToken = useAuthStore((state) => state.validateToken);
  const setIsAuthenticated = useAuthStore((state) => state.setIsAuthenticated);
  const setIsLoading = useAuthStore((state) => state.setIsLoading);
  const setUser = useAuthStore((state) => state.setUser);
  const setIsRegistred = useAuthStore((state) => state.setIsRegistred);
  const clearUser = useAuthStore((state) => state.clearUser);
  return {
    isAuthenticated,
    isLoading,
    user,
    isRegistred,
    setIsAuthenticated,
    setIsLoading,
    setUser,
    setIsRegistred,
    clearUser,
    validateToken,
  };
}

export default useAuth;